import { PlusOutlined } from '@ant-design/icons'
import { Button, Flex, Typography } from 'antd'
import { useUserProfile } from 'src/features/user'
import { GUARD_RULES } from 'src/features/session/constants'
import {
  ModalDeleteArticle,
  ModalDeleteArticleItem,
  ModalArticle,
  ArticleSkeleton,
} from 'src/pages/budget/budgetCategories/components'
import {
  useArticleList,
  useBudgetCategoriesGate,
} from 'src/pages/budget/budgetCategories/hook'
import { openModalArticle } from 'src/pages/budget/budgetCategories/model'
import { Article } from 'src/pages/budget/budgetCategories/widgets'
import { ModalArticleItem } from 'src/pages/budget/components'

export const BudgetCategories = () => {
  useBudgetCategoriesGate()
  const { articleList, loadingArticleList } = useArticleList()
  const userProfile = useUserProfile()

  const { Title } = Typography

  const hasPermissionAdd =
    userProfile.permissions.includes(GUARD_RULES.CREATE_BUDGET_ARTICLE)

  return (
    <>
      <Flex justify="space-between">
        <Title level={1}>Статьи Бюджета</Title>
        {hasPermissionAdd && (
          <Button
            size="large"
            icon={<PlusOutlined />}
            iconPosition="start"
            key="button_add_article"
            onClick={() => openModalArticle({ mode: 'new', article: null })}
            color="geekblue"
            variant="solid"
          >
            Добавить новую статью
          </Button>
        )}
      </Flex>
      <>
        {loadingArticleList ? (
          <ArticleSkeleton />
        ) : (
          <Flex vertical gap={24}>
            {articleList.map((article) => (
              <Article key={article.articleId} article={article} />
            ))}
          </Flex>
        )}
      </>
      <ModalArticle />
      <ModalDeleteArticle />
      <ModalArticleItem />
      <ModalDeleteArticleItem />
    </>
  )
}
